"use client";

import React from "react";
import { AuthProvider } from "@/src/contexts/AuthContext";
import { CartProvider } from "@/src/contexts/CartContext";
import { TenantProvider } from "@/src/contexts/TenantContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { FloatingCart } from "./components/FloatingCart";

export default function ShopLayout({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <CartProvider>
        <TenantProvider>
          <Header />
          <main>{children}</main>
          <Footer />
          <FloatingCart />
        </TenantProvider>
      </CartProvider>
    </AuthProvider>
  );
}
